import * as React from "react";
import { useState } from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import Collapse from "@mui/material/Collapse";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Box, Button, Typography, Alert } from "@mui/material";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import persian_en from "react-date-object/locales/persian_en";
import DateObject from "react-date-object";
import useMediaQuery from "@mui/material/useMediaQuery";
import InputLabel from "@mui/material/InputLabel";
import moment from "moment";
import Divider from "@mui/material/Divider";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2
import Pagination from "@mui/material/Pagination";
import TablePagination from "@mui/material/TablePagination";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Switch from "@mui/material/Switch";
import DialogData from "./DialogData";
import DisableCode from "./DisableCode";
import ShowDetailsCode from "./ShowDetailsCode";
import { customToastify } from "../../../utils/utilsFunctions";
import e from "react-date-object/calendars/persian";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function createData(name, data) {
  return { name, data };
}

// دیتاهای مورد نیاز و اسم نمایشی آنها را تعین میکند
const neededData = {
  _id: "جزییات بیشتر",
  marketingCode: "کد",
  firstMarketerProfit: "سود شمااز اولین خرید",
  firstUserDiscount: "تخفیف خریدار از اولین خرید",
  anotherMarketerProfit: "سود شما از خریدهای بعدی",
  anotherUserDiscount: "تخفیف کاربر از خریدهای بعدی",
  createdAt: "تاریخ ایجاد",
  status: "وضعیت",
  justForTest: "فقط برای تست",
};

export default function MyReferralCodesList(props) {
  const {
    fetchedMyReferralCodes,
    pageAndPerPage,
    setNumberPageAndPerPage,
    getCodeDetails,
  } = props;

  const RecivedData = fetchedMyReferralCodes["docs"];

  let allStatusCodeState = {};
  // هر مجموعه از دیتا را برای هر جدول درون یک المنت آرایه از listOfTable میریزد
  let listOfTable = RecivedData.map((el, index) => {
    const rowOfTableData = [];
    for (const property in el) {
      // دیتاهایی که در neededData گفته ایم نیاز داریم را جدا می کند
      if (neededData[property]) {
        // دیتاهایی که  بصورت تاریخ هستند - باید خودمان مشخص کنیم-. را تبدیل به تاریخ شمسی میکند
        if (
          property == "createdAt" ||
          property == "endingDate" ||
          property == "startingDate"
        ) {
          const date = new DateObject({
            date: el[property],
            calendar: persian,
            locale: persian_fa,
          });
          rowOfTableData.push(
            createData(neededData[property], {
              name: property,
              data: date.format(),
            })
          );
        } else if (property == "status") {
          allStatusCodeState[el._id] = el.status;
          rowOfTableData.push(
            createData(neededData[property], {
              name: property,
              data: el[property],
            })
          );
        } else if (property == "marketingCode") {
          rowOfTableData.push(
            createData(neededData[property], {
              name: property,
              data: <>
                <Typography>
                  {el[property]}
                </Typography>
                <Button sx={{ m: 0, p: 0, mr: 1 }} variant="outlined" onClick={() => { navigator.clipboard.writeText(`https://umlang.com/referral/rdp/${el[property]}`); customToastify("info", `https://umlang.com/referral/rdp/${el[property]} کپی شد`) }}>کپی لینک معرف</Button>
                <Button sx={{ m: 0, p: 0 }} variant="outlined" onClick={() => { navigator.clipboard.writeText(el[property]); customToastify("info", `${el[property]} کپی شد`) }}>کپی کد معرف</Button>
              </>,
            })
          );
        } else
          rowOfTableData.push(
            createData(neededData[property], {
              name: property,
              data: el[property],
            })
          );
      }
    }
    return rowOfTableData;
  });

  // اگر سایز صفحه از 600 پیکسل کوچکتر شود مقدار ترو برمیگرداند
  const detectSize600px = useMediaQuery("(min-width:600px)");
  const [openDialogContent, setOpenDialogContent] = React.useState(false);
  const [dialogTitle, setDialogTitle] = React.useState("");
  const [dialogContentData, setDialogContentData] = React.useState("");
  const [statusCodeState, setStatusCodeState] = React.useState({});

  const handleStatusCodeState = (packageId, content) => {
    setStatusCodeState({
      ...statusCodeState,
      [packageId]: content,
    });
  };
  const handleOpenDialogContent = () => {
    setOpenDialogContent(true);
  };
  const handleCloseDialogContent = () => {
    setOpenDialogContent(false);
  };

  //  فانکشنی برای نشان دادن پاپ آپ وابسته به کلیک بر روی دکمه های مختلف در جدول
  const setDialog = (type, dataContent) => {
    if (type == "DisableCode") {
      // let data = JSON.parse(e);
      // data.forEach((e) => {
      //   console.log(e);
      // });
      setDialogTitle("تغییر وضعیت کد معرف");
      handleOpenDialogContent();
      setDialogContentData(
        <DisableCode
          dataContent={dataContent}
          handleStatusCodeState={handleStatusCodeState}
          handleCloseDialogContent={handleCloseDialogContent}
        />
      );
    }
    if (type == "ShowDetailsCode") {
      // let data = JSON.parse(e);
      // data.forEach((e) => {
      //   console.log(e);
      // });
      setDialogTitle("جزییات");
      handleOpenDialogContent();
      setDialogContentData(
        <ShowDetailsCode
          dataContent={dataContent}
          handleStatusCodeState={handleStatusCodeState}
          handleCloseDialogContent={handleCloseDialogContent}
          getCodeDetails={getCodeDetails}
        />
      );
    }
  };

  // اطلاعات هر سطر را بر میگرداند و در صورت نیاز قبل از برگرداندن تغیراتی روی دیتا انجام می دهیم
  const showRowData = (index, data, oneRow) => {
    const getId = oneRow.filter((e) => e.data.name == "_id");
    const packageId = getId[0].data.data;
    const { name, data: content } = data;
    if (name == "status") {
      return (
        <StyledTableCell align="left">
          {" "}
          <Switch
            checked={
              packageId in statusCodeState
                ? statusCodeState[packageId]
                : content
            }
            onChange={() => {
              setDialog("DisableCode", {
                packageId,
                newStatus: !(packageId in statusCodeState
                  ? statusCodeState[packageId]
                  : content),
              });
              // handleStatusCodeState(packageId,!((packageId in statusCodeState) ?statusCodeState[packageId]:content));setDialog("DisableCode",{packageId});console.log(statusCodeState,"statusCodeStatestatusCodeState",(packageId in statusCodeState) ?statusCodeState[packageId]:content)
            }}
          />
        </StyledTableCell>
      );
    } else if (name == "_id")
      return (
        <StyledTableCell align="left">
          <Button
            data-id={JSON.stringify(content)}
            onClick={(e) => {
              setDialog("ShowDetailsCode", JSON.parse(e.target.dataset.id));
            }}
          >
            مشاهده دیگر جزییات
          </Button>
        </StyledTableCell>
      );
    else {
      return <StyledTableCell align="left">{content}</StyledTableCell>;
    }
  };

  return (
    <>
      <DialogData
        openDialogContent={openDialogContent}
        handleCloseDialogContent={handleCloseDialogContent}
        dialogTitle={dialogTitle}
      >
        {dialogContentData}
      </DialogData>
      <Box>
        {listOfTable.map((oneRow, index) => (
          <TableContainer
            key={`MainTable-${index}`}
            component={Paper}
            sx={{ mb: 1 }}
          >
            <Table sx={{ minWidth: 10 }} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell
                    sx={{ width: detectSize600px ? "25%" : "50%" }}
                  ></StyledTableCell>
                  <StyledTableCell
                    sx={{ width: detectSize600px ? "75%" : "50%" }}
                    align="left"
                  ></StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {oneRow.map((row) => (
                  <StyledTableRow key={row.name}>
                    <StyledTableCell component="th" scope="row">
                      {row.name}
                    </StyledTableCell>
                    {showRowData(index, row.data, oneRow)}
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          // <StyledTableRow key={row.name}>
          //   <StyledTableCell component="th" scope="row">
          //     {row.name}
          //   </StyledTableCell>
          //   <StyledTableCell align="left">{row.data}</StyledTableCell>
          // </StyledTableRow>
        ))}
        <Box sx={{ display: "flex", alignItems: "baseline" }}>
          <Pagination
            count={pageAndPerPage.totalPages}
            siblingCount={0}
            color="primary"
            hideNextButton={pageAndPerPage.hasNextPage}
            hidePrevButton={pageAndPerPage.hasPrevPage}
            // totalPages:0,
            // hasNextPage:false,
            // hasPrevPage:false,
            page={pageAndPerPage.page}
            // totalDocs:0,
            // totalPages: 0

            onChange={(e, value) => {
              setNumberPageAndPerPage("page", value);
            }}
          />
          {pageAndPerPage.totalPages == 0 ? null : (
            <>
              تعداد کل:{pageAndPerPage.totalDocs}
              <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                <InputLabel id="demo-select-small">تعداد در هر صفحه</InputLabel>
                <Select
                  labelId="demo-select-small"
                  id="demo-select-small"
                  defaultValue={5}
                  value={pageAndPerPage.perPage}
                  label="تعداد در هر صفحه"
                  onChange={(e) => {
                    setNumberPageAndPerPage("perPage", e.target.value);
                  }}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  <MenuItem value={5}>5</MenuItem>
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={20}>20</MenuItem>
                  <MenuItem value={35}>35</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                </Select>
              </FormControl>
            </>
          )}
        </Box>
      </Box>
    </>
  );
}
